import { FaEyeSlash } from "react-icons/fa";
import Tooltip from "../ToolTip";

const EmptyButton = ({ content }) => {
  return (
    <Tooltip content={content}>
      <button
        className="p-1.5 text-gray-500 rounded-md bg-gray-700 bg-opacity-10 flex iems-center"
      >
        <FaEyeSlash className="text-[10px]"/>
      </button>
    </Tooltip>
  )
}

export default EmptyButton;